import { render, staticRenderFns } from "./GeocitiesDecor.vue?vue&type=template&id=4875e7c3&"
import script from "./GeocitiesDecor.vue?vue&type=script&lang=ts&"
export * from "./GeocitiesDecor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports